var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-community-search-container" }, [
    _c("div", { staticClass: "grid-container" }, [
      _c("div", { staticClass: "c-community-search-heading" }, [
        _vm.searchResultsText
          ? _c("h2", { staticClass: "c-community-search-heading__title" }, [
              _vm._v("\n        " + _vm._s(_vm.searchResultsText) + "\n      ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.options.expandFilters
          ? _c(
              "a",
              {
                class: [
                  _vm.showFilters
                    ? "c-expand-filters c-expand-filters--open"
                    : "c-expand-filters"
                ],
                attrs: { href: "#" },
                on: { click: _vm.expandFilters }
              },
              [_vm._v(_vm._s(_vm.options.expandFilters.text))]
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showFilters,
            expression: "showFilters"
          }
        ],
        staticClass: "c-community-search"
      },
      [
        _c("div", { staticClass: "c-community-search__inner grid-container" }, [
          _c("div", { staticClass: "c-community-search__filters" }, [
            _c(
              "div",
              { staticClass: "c-community-search__column" },
              [
                _vm.options.sortByOptions
                  ? _c("drop-down", {
                      attrs: {
                        filters: _vm.options.sortByOptions,
                        "event-name": "updateSortBy"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.options.typeOptions
                  ? _c("drop-down", {
                      attrs: {
                        filters: _vm.options.typeOptions,
                        "event-name": "updateType"
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "c-community-search__column" },
              [_c("checkbox", { attrs: { filters: _vm.options.filters } })],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-community-search__btn-wrapper" }, [
            _c(
              "a",
              {
                staticClass: "c-button c-button--brand",
                attrs: { href: "#" },
                on: { click: _vm.filterEventHandler }
              },
              [_vm._v(_vm._s(_vm.options.buttonText))]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid-container" },
      [
        _vm.options.displayType === "activity"
          ? _c(
              "div",
              { staticClass: "c-community-search__results" },
              _vm._l(_vm.results, function(result) {
                return _c("activity-results-card", {
                  key: result.id,
                  attrs: { result: result }
                })
              }),
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.options.displayType === "project"
          ? _c(
              "div",
              {
                staticClass:
                  "c-community-search__results c-community-search__results--three-column"
              },
              _vm._l(_vm.results, function(result) {
                return _c("project-results-card", {
                  key: result.id,
                  attrs: { result: result }
                })
              }),
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.options.displayType === "project 2"
          ? _c(
              "div",
              {
                staticClass:
                  "c-community-search__results c-community-search__results--three-column"
              },
              _vm._l(_vm.results, function(result) {
                return _c("project-results-card-two", {
                  key: result.id,
                  attrs: { result: result }
                })
              }),
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.options.noResults && _vm.results.length === 0
          ? _c("div", { staticClass: "c-community-search__no-results" }, [
              _c("p", [_vm._v(_vm._s(_vm.noResultsText))])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.results.length > 0 && _vm.paginationStyle === "page-list"
          ? _c("search-paging", {
              attrs: {
                searchType: "documents",
                currentPage: _vm.pageNumber,
                totalPages: _vm.totalPages
              },
              on: { movePage: _vm.loadResultsPage }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.paginationStyle !== "page-list" &&
        _vm.options.loadMoreText &&
        _vm.pageNumber < _vm.totalPages
          ? _c("div", { staticClass: "c-community-search__btn-container" }, [
              _c(
                "button",
                {
                  staticClass: "c-button c-button--brand",
                  on: { click: _vm.loadMoreResultsHandler }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.options.loadMoreText) + "\n      "
                  )
                ]
              )
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47cbb36c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47cbb36c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/geneco/community-search-results/communitySearchResults.vue
// module id = 561
// module chunks = 0